var _circle, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarAgentCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2211_10805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2211_10805)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#E7F0F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2211_10805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3076 61.3846H18.1538C17.3891 61.3846 16.7692 62.0046 16.7692 62.7693C16.7692 63.534 17.3891 64.1539 18.1538 64.1539H70.3076C71.0723 64.1539 71.6922 63.534 71.6922 62.7693C71.6922 62.0046 71.0723 61.3846 70.3076 61.3846Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2438 32.5774H19.2152V61.4283H68.2438V32.5774Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 33.2308H14L44.5457 18L74 33.2308Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6964 31.2318L63.1842 31.1512L44.4236 21.4339L24.6964 31.2318Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3994 33.1277H17.75V34.3439H70.3994V33.1277Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8456 32.5774H21.6595V34.4416H26.8456V32.5774Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6819 34.4415H22.8232V61.4283H25.6819V34.4415Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0514 32.5774H32.8654V34.4416H38.0514V32.5774Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8877 34.4415H34.0289V61.4283H36.8877V34.4415Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6669 32.5774H50.4808V34.4416H55.6669V32.5774Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5035 34.4415H51.6448V61.4283H54.5035V34.4415Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2187 32.5774H61.0327V34.4416H66.2187V32.5774Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0552 34.4415H62.1965V61.4283H65.0552V34.4415Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2748 61.4284H40.1593V53.6852C40.1593 51.8491 41.6536 50.3607 43.4969 50.3607H44.1302C45.867 50.3607 47.2748 51.763 47.2748 53.4929V61.4284Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3723 44.6784H38.0134V41.0233C38.0134 40.1566 38.7188 39.4539 39.589 39.4539H39.8879C40.7078 39.4539 41.3723 40.1159 41.3723 40.9325V44.6784Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5349 44.6786H28.176V41.0234C28.176 40.1567 28.8814 39.454 29.7515 39.454H30.0504C30.8703 39.454 31.5348 40.116 31.5348 40.9326V44.6786H31.5349Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5349 55.8944H28.176V52.2393C28.176 51.3726 28.8814 50.6699 29.7515 50.6699H30.0504C30.8703 50.6699 31.5348 51.3319 31.5348 52.1486V55.8944H31.5349Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0291 44.6784H56.6702V41.0233C56.6702 40.1566 57.3755 39.4539 58.2457 39.4539H58.5447C59.3645 39.4539 60.0291 40.1159 60.0291 40.9325V44.6784Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0291 55.8944H56.6702V52.2393C56.6702 51.3726 57.3755 50.6699 58.2457 50.6699H58.5447C59.3645 50.6699 60.0291 51.3319 60.0291 52.1486V55.8944Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8649 44.6784H46.5059V41.0233C46.5059 40.1566 47.2113 39.4539 48.0814 39.4539H48.3803C49.2001 39.4539 49.8648 40.1159 49.8648 40.9325V44.6784H49.8649Z",
    fill: "#4B81AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2211_10805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 46.1538,
    fill: "white",
    transform: "translate(14 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAgentCompany);
export default __webpack_public_path__ + "static/media/avatar_agent_company.d7127752ecea05ddb6f6c446fe4e231a.svg";
export { ForwardRef as ReactComponent };